export const ARTIFACT_AUTO_COLLAPSE_MS = 3000;
export const PLAN_AUTO_COLLAPSE_MS = 2000;
export const REASONING_AUTO_COLLAPSE_MS = 1500;
export const MAX_EVENTS = 1000;
export const MAX_DEBUG_LINES = 220;
export const COMPOSER_MIN_LINES = 1;
export const COMPOSER_MAX_LINES = 2;
export const FRONTEND_VIEWPORT_TYPES = new Set(['html', 'qlc']);
export { ACCESS_TOKEN_STORAGE_KEY } from '@/shared/data/accessTokenStorage';
